interface GoalScorersProps {
  /** Additional CSS class names to apply to the component */
  className?: string;
  /** Array of goal scorers to display */
  goalScorers: string[];
}

export default function GoalScorers({ className = '', goalScorers }: GoalScorersProps) {
  return (
    <span
      className={`font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark ${className}`}
    >
      {goalScorers.join(', ')}
    </span>
  );
}
